<template>
  <div id="app">
    <!-- 公共头部 -->
    <app-header1 v-if="isHeader1"></app-header1>
	  <app-header v-else></app-header>
      <router-view  />
    <!-- 公共底部 -->
    <app-footer></app-footer>
    <div class="gotop" v-show="gotop" @click="toTop">
      <i class="iconfont icon-fanhuidingbu"></i>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Header1 from "@/components/Header1.vue";
import Footer from "@/components/Footer.vue";
export default {
  data() {
    return {
	  gotop: false,
	  isHeader1:false
    };
  },
  components: {
    "app-header": Header,
    "app-header1": Header1,
    "app-footer": Footer,
  },
  watch:{
    $route(to,from){
	  //console.log(to.path);//到哪去
        this.isHeader1=false
      // if(to.path=='/works'||to.path=='/member'||to.path=='/sponsor'){
      //   this.isHeader1=true
      // }else{
      //   this.isHeader1=false
      // }
    }
},
created(){

},
  mounted() {
	  
    // 此处true需要加上，不加滚动事件可能绑定不成功
    window.addEventListener("scroll", this.handleScroll, true);
    document.oncontextmenu=new Function("event.returnValue=false"); 
			document.onselectstart=new Function("event.returnValue=false");
  },
  methods: {
    handleScroll() {
      let scrolltop =
        document.documentElement.scrollTop || document.body.scrollTop;
      scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
    },
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 20);
    },
  },  
};
</script>
<style lang="less">
@import "~@/assets/less/common.less";
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

html,
body,
#app {
  // width: 100%;
  min-width:1440px;
  height: 100%;
  position: relative;
}
.gotop {
  width: 50px;
  height: 50px;
  align-items: center;
  justify-content: center;
  display: flex;
  text-align: center;
  position: fixed;
  right: 50px;
  bottom: 30px;
  cursor: pointer;
}
.gotop .iconfont {
  font-size: 40px;
  color: #1954c9;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}
a {
  text-decoration: none;
}
p {
  text-align: justify;
  font-size: 14px;
  text-indent: 28px;
  margin-bottom: 20px;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
div {
  box-sizing: border-box;
}
.container {
  // width: 1200px;
  width:60%;
  margin: 0 auto;
}
img {
  display: block;
}
#app /deep/ .el-tab-pane {
  box-sizing: border-box;
  padding-left: 50px;
}
// 二级页面
.second_banner {
  width: 100%;
  // min-width:1200px;
  height: auto;
  // margin-top: 110px;
  img {
    width: 100%;
    height: auto;
  }
}
.second_main {
  // width: 1200px;
  background: #fff;
  // border-radius: 20px;
  position: relative;
  // margin: -80px auto 80px;
  padding: 80px 56px 96px 70px;
  min-height: 765px;
  box-shadow: #c0c0c0 0px 0px 10px; //将h-shadow,v-shadow设为0px,实现四周阴影
  p {
    font-size: 14px;
    line-height: 24px;
    color: #7d7d7d;
  }
  .one_img {
    width: 450px;
    margin: 20px auto;
    img {
      width: 100%;
    }
  }
}
#app /deep/ .el-tabs--left .el-tabs__item.is-left{
  text-align: left;
}
#app /deep/ .el-tabs__item.is-active{
  color: #27487b;
}
#app /deep/ .el-tabs__active-bar{
  background-color: #1954c9;
}
</style>
